// src/pages/NotFound.js
import React from "react";
import Seo from "../components/Seo";

function PageNotFound() {
  return (
    <div className="text-center py-5">
      <Seo title="Page Not Found" noIndex />
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you're looking for does not exist.</p>
    </div>
  );
}

export default PageNotFound;
